import SpecialsPage from 'src/dispensary/specials';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(SpecialsPage, CoreMenuLayout);
